import { useLanguageRegionCode } from '@alltrails/core/hooks/useLanguageRegionCode';
import styles from './StripeApplePayButton.module.scss';

type Props = {
  onClick: () => void;
};

export default function StripeApplePayButton({ onClick }: Props) {
  const languageRegionCode = useLanguageRegionCode();

  return (
    <apple-pay-button
      buttonstyle="black"
      className={styles.button}
      locale={languageRegionCode}
      onclick={e => {
        e.preventDefault();
        onClick();
      }}
      type="continue"
    />
  );
}
